import * as React from "react";
import { Timeline } from "@mui/lab";
import { TimelineEntry } from "../../../../types/TimelineEntry";
import { TimelineEntryCardDesktop } from "./TimelineEntryCardDesktop";

export interface ITimelineDesktopProps {
  entries: TimelineEntry[];
}
export function TimelineDesktop(props: ITimelineDesktopProps) {
  return (
    <Timeline position="alternate">
      {props.entries.map((x, index) => {
        return (
          <TimelineEntryCardDesktop
            entry={x}
            leftSide={index % 2 == 1}
            key={x.organisation}
          />
        );
      })}
    </Timeline>
  );
}
